import { setCss, viewTransition } from '../functions.js';


/**
 * @since 2024-04-29 Show first element by default
 */
export default function TabsModule(element) {

    let tabs = [...element.querySelectorAll('a')];

    tabs.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            let kdHideSelector = link.getAttribute('kd-hide');
            let kdShowSelector= link.getAttribute('kd-show');

            viewTransition(() => {
                if (kdHideSelector) {
                    kdHideSelector.split(',').forEach(function(selector) {
                        selector = selector.trim();
                        setCss(selector, {
                            display: 'none'
                        })
                    });
                }

                if (kdShowSelector) {
                    setCss(kdShowSelector, {
                        display: ''
                    })
                }

                tabs.forEach(function(link) {
                    link.classList.remove('active');
                });

                e.target.classList.add('active');
            });

        });
    });

    let firstTab = tabs[0];
    firstTab.click();

}

window.modules = window.modules || {}
window.modules.TabsModule = TabsModule;
